// @flow
import React from 'react';
import { useDispatch } from 'react-redux';
import { showAlert } from 'actions/app';
import { executeRestoreSearchProjectsService } from 'services/searchProjects';
import strings from 'strings';

import DecisionDialog from '../../DecisionDialog';

const { restoreSearchProject: restoreDialogCopies } = strings.searchProjects.dialogs;

type RestoreSearchProjectDialogPropTypes = {
  isDialogFetching: boolean,
  onCloseDialog: () => {},
  onFetchingDialog: () => {},
  onSuccess: () => {},
  searchProjects: Object
};

const RestoreSearchProjectDialog = ({
  isDialogFetching,
  onCloseDialog,
  onFetchingDialog,
  onSuccess,
  searchProjects
}: RestoreSearchProjectDialogPropTypes) => {
  const dispatch = useDispatch();
  const shouldRestoreMultipleSearchProjects = searchProjects.length > 1;
  const finalSubject = shouldRestoreMultipleSearchProjects
    ? restoreDialogCopies.subject.plural
    : restoreDialogCopies.subject.singular;
  const finalTitle = strings.formatString(restoreDialogCopies.main.title, {
    subject: finalSubject
  });

  const handleRestoreSearchProject = async () => {
    onFetchingDialog(true);
    const { success, alert } = await executeRestoreSearchProjectsService(
      shouldRestoreMultipleSearchProjects,
      { searchProjects }
    );
    dispatch(showAlert(alert));
    onFetchingDialog(false);
    if (success) {
      onSuccess();
      onCloseDialog();
    }
  };
  const formattedMessage = strings.formatString(restoreDialogCopies.main.message, {
    subject: finalSubject
  });

  return (
    <DecisionDialog
      {...restoreDialogCopies.main}
      fetching={isDialogFetching}
      message={formattedMessage}
      onClose={onCloseDialog}
      onConfirm={handleRestoreSearchProject}
      title={finalTitle}
      withButtons="YesNo"
    />
  );
};

export default RestoreSearchProjectDialog;
